module.exports = __webpack_public_path__ + "static/media/frowning-face-svgrepo-com.7b8d7ff0.svg";